<template>
  <div class="invitation-response">
    <UserIcon class="user-icon" :userId="data.recipientId" userStatus="dark" />

    <div class="name">
      <span class="name__fullname">{{ user.recipientName }}</span>
      <span v-if="user.recipientPronouns && user.recipientPronouns != ''" class="name__pronouns">({{ user.recipientPronouns }})</span>
    </div>

    <newTimesince
      class="time"
      :timestamp="`${data.timestamp.indexOf('Z') === -1 ? `${data.timestamp}Z` : data.timestamp}`"
    />

    <div class="status">Declined your invite</div>
    <div class="message" v-if="message">{{message}}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import newTimesince from '@/components/sidebar/newTimesince.vue';
import UserIcon from '@/components/UserIcon.vue';

export default {
  name: 'InvitationResponse',
  components: {
    UserIcon,
    newTimesince
  },
  props: {
    notificationId: String
  },
  computed: {
    ... mapGetters(['getCurrentNotification']),
    message() {
      if (this.data.response !== "Declined") {
        return this.data.response
      }
      return ''
    },

    data() {
      return this.getCurrentNotification
    },

    user() {
      return this.data.data;
    }
  },
  created() {
    this.$emit('modalSettings', {
      styles: {
        'min-width': '350px',
        'max-width': '350px'
      },
      fullScreenOnMobile: false,
      hasCloseButton: true
    });
  },
  methods: {
    ...mapActions(['modal/close', 'clearCurrentNotification', 'cancelPinHandler']),
    cancel() {
      this['modal/close']();
      this.cancelPinHandler([this.user.pinsId]);
    },
  },
  beforeDestroy() {
    if (this.getCurrentNotification.id == this.notificationId) {
      this.clearCurrentNotification();
    }
  }
};
</script>
<style scoped lang="scss">
.user-icon {
  width: 80px;
  height: 80px;
}

.invitation-response {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.name {
  &__fullname {
    font-size: 1.125rem; /** 18px */
    color: white;
    font-weight: bold;
    margin-right: 8px;
    vertical-align: middle;
  }

  &__pronouns {
    color: $grey-1;
    font-size: 1rem;
    vertical-align: middle;
  }
}

.time {
  font-size: 0.875rem; /** 14px */
  font-weight: bold;
  color: $grey-1;
}

.status {
  margin-top: 20px;
  font-weight: bold;
  font-size: 1rem; /** 24px */
  color: $red;
  text-align: center;
}

.message {
  box-sizing: border-box;
  width: 100%;
  padding: 30px;
  border-radius: 15px;
  background-color: $grey-5;
  font-style: italic;
  font-weight: bold;
  margin-top: 10px;

}
</style>
